module.exports = __webpack_public_path__ + "img/image-thumb-17.7f514d41.webp";